import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { Language } from "@/hooks/use-browser-language";

interface LanguageSwitcherProps {
  language: Language;
  onToggle: () => void;
  className?: string;
}

export const LanguageSwitcher = ({ language, onToggle, className = "" }: LanguageSwitcherProps) => {
  return (
    <div className={`flex justify-center pt-6 border-t border-border/40 ${className}`}>
      <Button
        variant="ghost"
        size="sm"
        onClick={onToggle}
        className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
      >
        <Globe className="h-4 w-4" />
        <span className="font-medium">{language === "pl" ? "English" : "Polski"}</span>
      </Button>
    </div>
  );
};
